export const DATE_TIME_PICKER_MODEL = {
    DATE_TIME: 'DATE_TIME',
    DATE: 'DATE',
    TIME: 'TIME',
    RANGE: 'RANGE'
}
